// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-gray-900 p-6 pt-5 pb-30">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center">
        <div className="mb-4 md:mb-0">
          <p className="text-gray-300">© 2025 BoxyQR. All rights reserved.</p>
        </div>
        
        <div className="flex space-x-6">
          <Link 
            to="/privacy"
            className="text-white hover:text-gray-300 transition-colors"
          >
            Privacy Policy
          </Link>
          <Link 
            to="/terms"
            className="text-white hover:text-gray-300 transition-colors"
          >
            Terms of Service
          </Link>
        </div>
      </div>
      <div className="p-10"> </div>
    </footer>
  );
}

export default Footer;